module.exports = __webpack_public_path__ + "img/medical-prescription.2c3de3bf.svg";